import React, { useState } from "react";
import titletext from "../../Images/shutteltext.png";
import { Spinner } from "react-bootstrap";
import image1 from "../../Images/bgimg1.png";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { verifyemail } from "../../services/AuthService";
function Authverifyemail() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");
  const token = searchParams.get("token");
  const handleverify = () => {
    setLoading(true);
    const param = {
      uid: uid,
      token: token,
    };
    verifyemail(param)
      .then((res) => {
        toast.success("Email verify successfuly");
        navigate("/");
      })
      .catch((err) => {
        toast.error(err?.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "100vh",
        width: "100vw",
        backgroundImage: `url(${image1})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        className="card shadow-sm rounded p-4"
        style={{ maxWidth: "400px", margin: "auto" }}
      >
        <div className="text-center mb-4">
          <img src={titletext} alt="Logo" width="180" className="img-fluid" />
        </div>
        <h5 className="text-center mb-3">Verify your email</h5>
        <p className="text-dark text-center mb-4">
          Click the button below to verify your email address.
        </p>
        <div className="d-flex justify-content-center">
          <button className="btn btn-primary px-4" onClick={handleverify}>
            {loading ? (
              <>
                <Spinner
                  className="me-1"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
                <span>Loading...</span>
              </>
            ) : (
              "Verify"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Authverifyemail;
